import { render } from "./InstagramComponent.vue?vue&type=template&id=b58543e8&scoped=true"
import script from "./InstagramComponent.vue?vue&type=script&lang=js"
export * from "./InstagramComponent.vue?vue&type=script&lang=js"

import "./InstagramComponent.vue?vue&type=style&index=0&id=b58543e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b58543e8"]])

export default __exports__